module.exports = __webpack_public_path__ + "img/adPdfIcon.fc07bfe5.svg";